export const COHORT = 'cohort';
export const NOT_ENROLLED = 'not-enrolled';
export const CONTROL = 'control';
export const VARIATION = 'variation';
export const EXPERIMENT = 'experiment';
